import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			La denominatoro en ajna fraktumo estas siaspeca piedestalo. 
			Ju pli malgranda estas la fraktumo, des pli grandan denominatoron ĝi bezonas.
		</p>
		`
	)
}

const itemName = {
	esp: 'Fraktumo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;